module.exports = __webpack_public_path__ + "img/boy1.ac2a5817.jpg";